import objects from './objects/'; // click action objects schemas for GTM

// actions map will proxy the
const actionsMap = {
  ['NEWSLETTER_SIGN_UP']: () => {
    _trackAnalytics(objects.newsletterSignUp);
  },
};

const _trackAnalytics = (schema) => {
  try {
    if (schema) {
      window.dataLayer.push(schema);
      console.warn('GTM Tracking: ', schema); // eslint-disable-line no-console
    }
  } catch (e) {
    console.warn('GTM Tracking wasn`t initiated properly, tried to track: ', schema); // eslint-disable-line no-console
  }
};

export default function recorder(event) {
  const fn = actionsMap[event.type];
  if (fn) {
    fn(event);
  }
}
